import {Pipe, PipeTransform} from "@angular/core";
import {InvoiceStatus} from "src/enums/invoice-status.enum";
@Pipe({
    name: "invoiceStatus",
    standalone: false
})
export class InvoiceStatusPipe implements PipeTransform {
    constructor() { }

    transform(value?: number): string | void {
        if (typeof value === 'undefined' || value < 0) return;

        return InvoiceStatus[value];
    }
}
